import http from '../http'

export function uploadShipmentAttachment(formData) {
  return http.post('/shipment-attachments/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  })
}

export function getShipmentAttachments(logisticsInfoId, category) {
  return http.get(`/shipment-attachments/logistics/${logisticsInfoId}`, {
    params: category ? { category } : {}
  })
}

export function downloadShipmentAttachment(attachmentId) {
  return http.get(`/shipment-attachments/download/${attachmentId}`, {
    responseType: 'blob'
  })
}

export function deleteShipmentAttachment(attachmentId) {
  return http.delete(`/shipment-attachments/${attachmentId}`)
}
